/*
 * Where: src/constants/routes.js
 * What: Route path constants.
 * Why: Centralize URL management for react-router-dom.
 */
export const ROUTE_PATHS = {
    root: '/',
    top: '/index.html',
    howToUse: '/howtouse.html',
    howToUseAlias: '/howtouse',
    read: '/read.html',
    readAlias: '/read',
};
